export default {"src":"/_next/static/media/En.bbc44a52.svg","height":89,"width":135};